import React, { useState, useEffect } from 'react';
import SectionView from './section-view'
const SectionContainer = ({
  id,
  index,
  moveToBottom,
  moveToTop,
  onAddSectionClick,
  onChangePhoto,
  onChangePosition,
  onCreatePhoto,
  onRemovePhoto,
  onRemoveSectionClick,
  onSectionTextChange,
  onSectionTitleChange,
  order,
  photo,
  text,
  title,
}) => {
  const [showPhoto, setShowPhoto ] = useState(false);

  const onToggleDropdown = () => {
    setShowPhoto(!showPhoto);
  }

  useEffect(()=>{
    if(!!photo.id){
      setShowPhoto(true);
    }
  }, [photo]);

  const onTitleChange = text => {
    onSectionTitleChange(id, text);
  }

  const onTextChange = text => {
    onSectionTextChange(id, text);
  }

  const onDeleteClick = () => {
    onRemoveSectionClick(id);
  }

  const onAddSectionBelow = () => {
    onAddSectionClick(index + 1);
  }

  return(
    <SectionView
      id={id}
      index={index}
      moveToBottom={moveToBottom}
      moveToTop={moveToTop}
      onAddSectionBelow={onAddSectionBelow}
      onChangePhoto={onChangePhoto}
      onChangePosition={onChangePosition}
      onCreatePhoto={onCreatePhoto}
      onDeleteClick={onDeleteClick}
      onRemovePhoto={onRemovePhoto}
      onTextChange={onTextChange}
      onTitleChange={onTitleChange}
      onToggleDropdown={onToggleDropdown}
      order={order}
      photo={photo}
      showPhoto={showPhoto}
      text={text}
      title={title}
    />
  )
}

export default SectionContainer;
